import { Camera, EventDispatcher, Vector3 } from 'three';

import { NormalizedPointer } from '../../math/index.js';

export interface IControls<TEventMap extends {} = {}> extends EventDispatcher<TEventMap> {
  enabled: boolean;
  connect(domElement: HTMLElement): void;
  disconnect(): void;
}

/**
 * Abstract base class for controls. This class should always be inherited when creating new controls
 * in order to ensure that all the proper methods and properties are implemented.
 */
export abstract class BaseControls<TEventMap extends {} = {}>
  extends EventDispatcher<TEventMap>
  implements IControls<TEventMap>
{
  protected _camera: Camera;
  protected _domElement: HTMLElement | null = null;
  protected _pointer: NormalizedPointer | null = null;
  protected _target: Vector3 = new Vector3();

  public enabled = true;

  /**
   * Drei useBounds expects controls to have a target point
   */
  get target() {
    return this._target;
  }

  constructor(camera: Camera, domElement?: HTMLElement) {
    super();
    this._camera = camera;
    if (domElement) {
      this.connect(domElement);
    }
  }

  // eslint-disable-next-line no-unused-vars, unused-imports/no-unused-vars
  connect(domElement: HTMLElement, pointer?: NormalizedPointer): void {
    throw new Error('Method BaseControls.connect not implemented.');
  }

  disconnect(): void {
    throw new Error('Method BaseControls.disconnect not implemented.');
  }
}

export default BaseControls;
